define('helpers/RemindersHelper',[], function () {
  "use strict";

  var $ = require("jquery"),
    i18n = require("i18n"),
    Config = require("env");

  var RemindersHelper = {
    getUserNewFreeParams: function () {
      return {
        lang: i18n.lng(),
        title: $.i18n.translate("PUBLIC.REMINDERS.USER_NOT_VALIDATED.TITLE"),
        message:
          $.i18n.translate("PUBLIC.REMINDERS.USER_NOT_VALIDATED.MESSAGE") +
          "<br />" +
          $.i18n.translate("PUBLIC.REMINDERS.USER_NOT_VALIDATED.MESSAGELINKS"),
        closeable: true,
        type: "warning",
        icon: "CreditCardIcon",
      };
    },

    getUserNotBillingDetailsParams: function () {
      return {
        lang: i18n.lng(),
        title: $.i18n.translate("PUBLIC.REMINDERS.USER_NOT_BILLING_DATA.TITLE"),
        message: $.i18n.t("PUBLIC.REMINDERS.USER_NOT_BILLING_DATA.MESSAGE", {
          my_account_payments_links: Config.paymentsUrl + "account/my-account",
          escapeInterpolation: false,
        }),
        closeable: true,
        type: "warning",
        icon: "UserIcon",
      };
    },
  };

  return RemindersHelper;
});

